import { useMemo, useState } from "react";
import { personArchive } from "@/mocks/gossip";

const FILTERS = [
  { key: "all", label: "全部人物" },
  { key: "collapse", label: "已塌房" },
  { key: "filed", label: "争议中" },
  { key: "verify", label: "已反转" },
];

const STATUS_STYLE: Record<string, string> = {
  collapse: "bg-primary-100 text-primary-700",
  filed: "bg-accent-100 text-accent-800",
  verify: "bg-secondary-100 text-secondary-700",
};

const STATUS_ICON: Record<string, string> = {
  collapse: "ri-close-circle-fill",
  filed: "ri-time-fill",
  verify: "ri-check-double-fill",
};

export default function Archive() {
  const [active, setActive] = useState("all");

  const list = useMemo(
    () =>
      active === "all" ? personArchive : personArchive.filter((p) => p.status === active),
    [active]
  );

  return (
    <section id="archive" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span> 人物档案
            </p>
            <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950">
              关键人物 · 塌房进度一手掌握
            </h2>
            <p className="mt-3 text-sm text-foreground-600">
              为每位被卷入舆论漩涡的海外博主建立档案卡，记录其事件状态、核心争议点与相关关键词，一键直达对应吃瓜现场。
            </p>
          </div>
          <div className="inline-flex items-center gap-1 rounded-full bg-background-100 p-1 self-start lg:self-auto overflow-x-auto max-w-full">
            {FILTERS.map((f) => (
              <button
                key={f.key}
                type="button"
                onClick={() => setActive(f.key)}
                className={`px-3.5 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  active === f.key
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-700 hover:text-primary-700"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {list.map((p) => (
            <article
              key={p.id}
              className="group rounded-2xl bg-background-100/70 border border-background-200 p-5 hover:border-primary-300 transition-colors flex flex-col"
            >
              <div className="flex items-start gap-4">
                <span className="flex items-center justify-center w-14 h-14 rounded-2xl bg-background-50 border border-background-200 font-heading font-black text-xl text-primary-600 shrink-0">
                  {p.alias}
                </span>
                <div className="min-w-0">
                  <h3 className="font-heading font-bold text-lg text-foreground-950 truncate">
                    {p.nameEn}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">
                    {p.region} · {p.field}
                  </p>
                  <div className="mt-2 inline-flex items-center gap-1.5 text-xs text-foreground-700">
                    <i className="ri-group-line text-accent-600"></i>
                    <span className="font-medium">{p.follower}</span>
                    <span className="text-foreground-400">粉丝</span>
                  </div>
                </div>
              </div>

              <div className="mt-4 flex items-center justify-between">
                <span
                  className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${STATUS_STYLE[p.status]}`}
                >
                  <i className={STATUS_ICON[p.status]}></i>{p.statusText}
                </span>
                <span className="font-latin text-lg text-foreground-300">#{String(p.id).padStart(2, "0")}</span>
              </div>

              <p className="mt-3 text-sm text-foreground-700 bg-background-50 rounded-xl px-3 py-2.5 flex gap-2">
                <i className="ri-focus-3-line text-primary-600 shrink-0 mt-0.5"></i>
                <span>{p.keyPoint}</span>
              </p>

              <div className="mt-4 flex flex-wrap gap-1.5">
                {p.keywords.map((k) => (
                  <span key={k} className="rounded-full bg-background-200 text-foreground-700 px-2.5 py-0.5 text-[11px]">
                    #{k}
                  </span>
                ))}
              </div>

              <a
                href="#hot"
                className="mt-5 inline-flex items-center justify-between rounded-xl border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors group-hover:bg-background-50"
              >
                查看完整吃瓜记录
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </article>
          ))}
        </div>

        <p className="mt-6 text-center text-xs text-foreground-500">
          人物档案基于公开信息整理 · 更多历史人物请在话题库中检索
        </p>
      </div>
    </section>
  );
}